import styled from 'styled-components';

export const FundName = styled.div`
  font-weight: 600;
  line-height: 24px;
`;
